<template><section><template>
<h3>Nav</h3>
<div class="bs-docs-section">
<div class="bs-example">
<n3-nav :default-active="activeIndex" mode="horizontal" @select="handleSelect">
<n3-nav-item index="1">Nav one </n3-nav-item>
<n3-sub-nav index="2">
<template slot="title">Nav two</template>
<n3-nav-item index="2-1">Item one</n3-nav-item>
<n3-nav-item index="2-2">Item two</n3-nav-item>
<n3-nav-item index="2-3">Item three</n3-nav-item>
</n3-sub-nav>
<n3-nav-item index="3"><a href="#" target="_blank">Nav three</a></n3-nav-item>
</n3-nav>
<pre v-pre=""><code v-pre="" class="language-html"><span class="hljs-tag">&lt;<span class="hljs-name">n3-nav</span>  <span class="hljs-attr">:default-active</span>=<span class="hljs-string">"activeIndex"</span>  <span class="hljs-attr">mode</span>=<span class="hljs-string">"horizontal"</span> <span class="hljs-attr">@select</span>=<span class="hljs-string">"handleSelect"</span>&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">n3-nav-item</span> <span class="hljs-attr">index</span>=<span class="hljs-string">"1"</span>&gt;</span>Nav one <span class="hljs-tag">&lt;/<span class="hljs-name">n3-nav-item</span>&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">n3-sub-nav</span> <span class="hljs-attr">index</span>=<span class="hljs-string">"2"</span>&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">template</span> <span class="hljs-attr">slot</span>=<span class="hljs-string">"title"</span>&gt;</span>Nav two<span class="hljs-tag">&lt;/<span class="hljs-name">template</span>&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">n3-nav-item</span> <span class="hljs-attr">index</span>=<span class="hljs-string">"2-1"</span>&gt;</span>Item one<span class="hljs-tag">&lt;/<span class="hljs-name">n3-nav-item</span>&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">n3-nav-item</span> <span class="hljs-attr">index</span>=<span class="hljs-string">"2-2"</span>&gt;</span>Item two<span class="hljs-tag">&lt;/<span class="hljs-name">n3-nav-item</span>&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">n3-nav-item</span> <span class="hljs-attr">index</span>=<span class="hljs-string">"2-3"</span>&gt;</span>Item three<span class="hljs-tag">&lt;/<span class="hljs-name">n3-nav-item</span>&gt;</span>
<span class="hljs-tag">&lt;/<span class="hljs-name">n3-sub-nav</span>&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">n3-nav-item</span> <span class="hljs-attr">index</span>=<span class="hljs-string">"3"</span>&gt;</span><span class="hljs-tag">&lt;<span class="hljs-name">a</span> <span class="hljs-attr">href</span>=<span class="hljs-string">"#"</span> <span class="hljs-attr">target</span>=<span class="hljs-string">"_blank"</span>&gt;</span>Nav three<span class="hljs-tag">&lt;/<span class="hljs-name">a</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">n3-nav-item</span>&gt;</span>
<span class="hljs-tag">&lt;/<span class="hljs-name">n3-nav</span>&gt;</span>
</code></pre>
<n3-nav default-active="2" theme="dark" @open="handleOpen" @close="handleClose" :style="{width:'180px'}">
<n3-sub-nav index="1">
<template slot="title"><n3-icon type="bars"></n3-icon>Nav one</template>
<n3-nav-group title="Group one" key="1">
<template slot="title">Group one</template>
<n3-nav-item index="1-1" key="1-1">Item one</n3-nav-item>
<n3-nav-item index="1-2" key="1-2">Item two</n3-nav-item>
</n3-nav-group>
<n3-nav-group title="Group two" key="2">
<n3-nav-item index="1-3" key="1-2">Item three</n3-nav-item>
</n3-nav-group>
<n3-sub-nav index="1-4">
<template slot="title">Item three</template>
<n3-nav-item index="1-4-1">Item one</n3-nav-item>
</n3-sub-nav>
</n3-sub-nav>
<n3-nav-item index="2"><n3-icon type="eye"></n3-icon>Nav two</n3-nav-item>
<n3-nav-item index="3"><n3-icon type="cloud"></n3-icon>Nav three</n3-nav-item>
</n3-nav>
</div>
<h3>n3-nav Params</h3>
<table>
<thead>
<tr>
<th>name</th>
<th>type</th>
<th>default</th>
<th>description</th>
</tr>
</thead>
<tbody>
<tr>
<td>mode</td>
<td>String</td>
<td>horizontal,vertical</td>
<td>vertical</td>
</tr>
<tr>
<td>theme</td>
<td>String</td>
<td>light,dark</td>
<td>light</td>
</tr>
<tr>
<td>default-active</td>
<td>String</td>
<td>-</td>
<td>default index</td>
</tr>
<tr>
<td>default-openeds</td>
<td>Array</td>
<td>—</td>
<td>default opened indexs</td>
</tr>
<tr>
<td>unique-opened</td>
<td>Boolean</td>
<td>—</td>
<td>false</td>
</tr>
<tr>
<td>menu-trigger</td>
<td>String</td>
<td>hover</td>
<td>subnav open type(only works when mode is <code v-pre="">horizontal</code>)</td>
</tr>
<tr>
<td>router</td>
<td>Boolean</td>
<td>false</td>
<td>vue-router , index as path</td>
</tr>
</tbody>
</table>
<h3>Events</h3>
<table>
<thead>
<tr>
<th>name</th>
<th>description</th>
<th>params</th>
</tr>
</thead>
<tbody>
<tr>
<td>select</td>
<td>item selected</td>
<td><code v-pre="">index</code>,<code v-pre="">indexPath</code> of selected item</td>
</tr>
<tr>
<td>open</td>
<td>SubMenu open</td>
<td><code v-pre="">index</code> ,<code v-pre="">indexPath</code> of opened subMenu</td>
</tr>
<tr>
<td>close</td>
<td>SubMenu close</td>
<td><code v-pre="">index</code>,<code v-pre="">indexPath</code> of closed subMenu</td>
</tr>
</tbody>
</table>
<h3>n3-sub-nav Params</h3>
<table>
<thead>
<tr>
<th>name</th>
<th>type</th>
<th>default</th>
<th>description</th>
</tr>
</thead>
<tbody>
<tr>
<td>index</td>
<td>String</td>
<td>-</td>
<td></td>
</tr>
</tbody>
</table>
<h3>n3-nav-item Params</h3>
<table>
<thead>
<tr>
<th>name</th>
<th>type</th>
<th>default</th>
<th>description</th>
</tr>
</thead>
<tbody>
<tr>
<td>index</td>
<td>String</td>
<td>-</td>
<td></td>
</tr>
<tr>
<td>route</td>
<td>Object</td>
<td>-</td>
<td>Vue Router Object</td>
</tr>
</tbody>
</table>
<h3>n3-nav-group Params</h3>
<table>
<thead>
<tr>
<th>name</th>
<th>type</th>
<th>default</th>
<th>description</th>
</tr>
</thead>
<tbody>
<tr>
<td>title</td>
<td>String</td>
<td>-</td>
<td>group</td>
</tr>
</tbody>
</table>
</div>
</template>

</section></template>

<script>
export default {
  data () {
    return {
      activeIndex: 1,
      show2: false
    }
  },
  methods:{
    handleSelect(){

    },
    handleOpen(){

    },
    handleClose(){

    }
  }
}
</script>


// WEBPACK FOOTER //
// n3NavDocs.md?3a14f957